import PropTypes from 'prop-types'
import { routerPropTypes } from 'Types'
import React from 'react'
import { useQuery } from '@apollo/client'
import { GET_HERO_CONTENT_CARD } from 'Queries'
import { ErrorView, Link } from 'Blocks'
import { skin, path } from 'Utils'
import skins from './skins'
import config from 'Config'

const HeroArticleContainer = props => {
  const Loading = () => <div className={`${props.className} loading`}></div>
  const queryString = props.location.search
  const urlParams = new URLSearchParams(queryString)
  const variables = {
    arguments: {
      isHero: true,
      isHome: urlParams.get('theme') ? false : true,
      theme: urlParams.get('theme') || '',
      state: 'PUBLISHED'
    }

  }

  const { loading: aLoading, error: aError, data: aData } = useQuery(GET_HERO_CONTENT_CARD, {
    variables
  });
  
  if (aLoading) return <Loading />
  if (aError) return null

  const aPath = () => {
    return path(aData.content.type, {uuid: aData.content.uuid, slug: aData.content.slug});
  }

  const tagClass = {
    hc: 'tag-orange',
    us: 'tag-brown'
  }

  return (
    <>
    {aData && aData.content &&
    <div className={props.className}>
    <div className="hero-banner category-page" style={{backgroundImage: `URL(${(props.screenType === 'small' && aData.content.image.mhero !== '' ? aData.content.image.mhero : aData.content.image.hero)})`}}>
      <div className="banner-container">
        <div className="banner-content-section">
          <div className="banner-title">
            <span className={`content-tag ${tagClass[config.name] || ''}`}>{aData.content.theme} </span>
          </div>
          <div className="banner-heading">{aData.content.title.short}</div>
          <div className="banner-button-row">
            <Link to={aPath()} className={config.name === 'sb' ? 'banner-link' : 'primary-link link-linen'}>Read More</Link>
          </div>
        </div>
      </div>
    </div>
    </div>
    }
    </>
  )
}

HeroArticleContainer.propTypes = {
  className: PropTypes.any,
  theme: PropTypes.any,
  ...routerPropTypes
}

export default skin(HeroArticleContainer, skins)
